import { getEstadoMeta } from "@/lib/solicitudEstados";

interface EstadoBadgeProps {
  estado?: string | null;
  size?: "sm" | "md";
}

export default function EstadoBadge({ estado, size = "sm" }: EstadoBadgeProps) {
  const meta = getEstadoMeta(estado);
  const padding = size === "sm" ? "px-2.5 py-1 text-xs" : "px-3 py-1.5 text-sm";

  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border font-label font-medium ${meta.badge} ${padding}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} aria-hidden="true"></span>
      {meta.label}
    </span>
  );
}